export const MerchantLogin = {
  loginApi: async (phone: string, password: string, rememberToken: boolean) => {
    const apiUrl = (process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000").replace(/\/$/, "");
    const res = await fetch(`${apiUrl}/api/merchant/login`, {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ phone, password, remember_token: rememberToken }),
    });

    const contentType = res.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await res.text();
      console.error("Non-JSON response (first 500 chars):", text.substring(0, 500));
      throw new Error(`Server returned HTML/error page instead of JSON. Status: ${res.status}. Check if backend is running at ${apiUrl}`);
    }

return res.json();
  },

  // Generate a random OTP for testing
  generateOTP: (): string => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  },

  // Reset password with OTP
  resetPassword: async (
    phone: string,
    otp: string,
    password: string,
    passwordConfirmation: string,
  ) => {
    const apiUrl = (
      process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000"
    ).replace(/\/$/, "");
    try {
      const res = await fetch(`${apiUrl}/api/merchant/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          phone,
          otp,
          password,
          password_confirmation: passwordConfirmation,
        }),
      });

      // Check if response is JSON
      const contentType = res.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        const text = await res.text();
        console.error("Non-JSON response:", text.substring(0, 200));
        throw new Error("Server returned an invalid response");
      }

      return res.json();
    } catch (error) {
      console.error("Reset password error:", error);
      throw error;
    }
  },
};
